<template>
    <div class="carshop-wrap">
        <h3>我的购物车</h3>
        <table border="0" v-if="car_list.length > 0">
            <thead>
                <tr>
                    <td width="100">
                        <div class="td1" @click="all_fun">
                            <div
                                class="m-checkbox"
                                :class="{ 'm-checkboxed': all_result }"
                            >
                                <i class="el-icon-check"></i>
                            </div>
                            <p class="u-m-l-8">全部</p>
                        </div>
                    </td>
                    <td class="u-text-left">商品</td>
                    <td width="80">单价</td>
                    <td width="150">数量</td>
                    <td width="80">小计</td>
                    <td width="80">操作</td>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in car_list" :key="index">
                    <td>
                        <div class="td1">
                            <div
                                class="m-checkbox"
                                :class="{ 'm-checkboxed': item.is_selected }"
                                @click="radio_change(item, index)"
                            >
                                <i class="el-icon-check"></i>
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="u-flex">
                            <div class="m-goods_img">
                                <img :src="item.image" alt="" />
                            </div>
                            <div class="m-goods_title u-line-2 u-m-l-12">
                                <span>{{ item.title }}</span>
                            </div>
                            <div class="m-goods_spce u-m-l-20">
                                <span>{{ item.key_vals }}</span>
                            </div>
                        </div>
                    </td>
                    <td class="u-text-center">￥{{ item.price_sale }}</td>
                    <td class="u-text-center">
                        <el-input-number
                            size="small"
                            :min="1"
                            :index="index"
                            v-model="item.num"
                            :key="item.id"
                            @change="inputNumChange"
                        ></el-input-number>
                    </td>
                    <td class="u-text-center m-td-price">
                        ￥{{ getSumPrice(item) }}
                    </td>
                    <td class="u-text-center">
                        <el-popconfirm
                            title="确定删除吗？"
                            @confirm="delconfirm(item, index)"
                        >
                            <span class="m-td-del" slot="reference">删除</span>
                        </el-popconfirm>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="carShop-wrap_box" v-if="car_list.length > 0">
            <div class="carShop-wrap_box_left">
                <div class="u-flex" @click="all_fun">
                    <div
                        class="m-checkbox"
                        :class="{ 'm-checkboxed': all_result }"
                    >
                        <i class="el-icon-check"></i>
                    </div>
                    <p class="carShop-wrap_box_font1 u-m-l-8">全部</p>
                </div>
                <p
                    class="carShop-wrap_box_font2 u-m-l-30"
                    @click="delSelectedFun"
                >
                    删除选中
                </p>
                <el-popconfirm
                    title="确定清空购物车吗？"
                    @confirm="clearAllFun()"
                >
                    <p class="carShop-wrap_box_font2 u-m-l-30" slot="reference">
                        清空购物车
                    </p>
                </el-popconfirm>
            </div>
            <div class="u-flex">
                <p class="u-m-r-30">
                    <span class="carShop-wrap_box_font4">已选择</span>
                    <span class="carShop-wrap_box_font5">{{
                        selected_count
                    }}</span>
                    <span class="carShop-wrap_box_font4">件商品</span>
                </p>
                <p class="carShop-wrap_box_font4">总价：</p>
                <p class="carShop-wrap_box_font3 u-m-r-30">￥{{ price }}</p>
                <div class="carShop-wrap_box_btn" @click="toPay">
                    <span>去结算</span>
                </div>
            </div>
        </div>

        <el-empty
            v-if="car_list.length == 0"
            description="购物车是空的"
        ></el-empty>
    </div>
</template>

<script >
import cache from "@/utils/cache"
export default {
    data() {
        return {
            all_result: false,
            num3: 1,
            price: 0,
            car_list: [],
            selected_count: 0,
        };
    },
    computed: {
        getSumPrice: function () {
            return (item) => {
                return (Number(item.price_sale) * Number(item.num)).toFixed(2);
            };
        },
    },
    created() {
        this.getCarList();
    },
    methods: {
        //获取购物车数据
        getCarList() {
            this.$http.get("gouwuche_lists", {}).then((res) => {
                if (res.code == 1) {
                    res.data.forEach((item, index) => {
                        item["is_selected"] = false;
                    });
                    this.car_list = res.data;
                    this.all_fun();
                }
            });
        },
        //全选
        all_fun() {
            if (this.car_list.length == 0) {
                this.all_result = false;
                return false;
            }
            this.all_result = !this.all_result;
            if (this.all_result) {
                this.selected_count = 0;
                this.car_list.forEach((item, index) => {
                    item["is_selected"] = true;
                    this.car_list[index] = item;
                    this.selected_count += 1;
                    this.price = (
                        Number(this.price) + Number(item.price_sale * item.num)
                    ).toFixed(2);
                });
            } else {
                this.selected_count = 0;
                this.car_list.forEach((item, index) => {
                    item["is_selected"] = false;
                    this.car_list[index] = item;
                    this.price = 0;
                });
            }
        },
        //选中单个产品
        radio_change(item, index) {
            item.price_sale = Number(item.price_sale);
            this.car_list[index]["is_selected"] = !item.is_selected;
            if (this.car_list[index]["is_selected"]) {
                this.selected_count += 1;
                this.price = (
                    Number(this.price) + Number(item.price_sale * item.num)
                ).toFixed(2);
                this.all_result =
                    this.car_list.length != 0 &&
                    this.selected_count == this.car_list.length
                        ? true
                        : false;
            } else {
                this.selected_count -= 1;
                this.price = (
                    Number(this.price) - Number(item.price_sale * item.num)
                ).toFixed(2);
                this.all_result = false;
            }
        },
        //计步器改变
        inputNumChange(newVal, oldVal, index) {
            let item = this.car_list[index] 
            this.$http.get('gouwuche_updateNum',{
                inventoryId: item.inventoryId,
				num: newVal
            }).then(res=>{
                if(res.code == 1){
                    this.getSumPriceFun()
                }else{
                    this.$message.error(res.message)
                }
            })
        },
        //计算选中总价
        getSumPriceFun(){
            let price = 0
            this.car_list.forEach(item=>{
                if(item.is_selected){
                    price = Number(price) + Number(item.price_sale)  * Number(item.num)
                }
            })
            this.price = price.toFixed(2)
        },
        delconfirm(item, index) {
            this.$http
                .get("gouwuche_del", {
                    inventoryId: item.inventoryId,
                })
                .then((res) => {
                    if (res.code == 1) {
                        if (item.is_selected) {
                            item.num = item.num === 0 ? 1 : item.num;
                            this.price = (
                                Number(this.price) -
                                Number(item.price_sale * item.num)
                            ).toFixed(2);
                        }
                        this.car_list.splice(index, 1);
                    }
                });
        },
        //删除选中的
        delSelectedFun() {
            let ids = [];
            let indx = [];
            this.car_list.forEach((item, index) => {
                if (item.is_selected) {
                    ids.push(item.inventoryId);
                    indx.push(index);
                }
            });
            if (ids.length == 0) {
                this.$message.error("请选择要删除的商品");
                return false;
            }
            this.$http
                .get("gouwuche_del", {
                    inventoryId: ids.join(","),
                })
                .then((res) => {
                    if (res.code == 1) {
                        indx.forEach((i) => {
                            let item = this.car_list[i];
                            if (item.is_selected) {
                                item.num = item.num === 0 ? 1 : item.num;
                                this.price = (
                                    Number(this.price) -
                                    Number(item.price_sale * item.num)
                                ).toFixed(2);
                            }
                            this.car_list.splice(i, 1);
                        });
                    }
                });
        },
        //清空购物车
        clearAllFun() {
            this.$http.get('gouwuche_delAll',{}).then(res=>{
                if(res.code == 1){
                    this.car_list = []
                    this.price = 0
                    this.all_result = false
                    this.selected_count = 0
                }else{
                    this.$message.error(res.message)
                }
            })
        },
        //去结算
        toPay(){
            let product_info = []
            let arr = []

            this.car_list.forEach(item=>{
                if(item.is_selected){
                    product_info.push({
                        "inventoryId": item.inventoryId,
                        "productId": item.productId,
                        "num": item.num
                    })
                    arr.push({
                        image: item.image,
                        title: item.title,
                        price_sale: item.price_sale,
                        num: item.num,
                        key_vals:item.key_vals
                    })
                }
            })

            cache.set('order_info', JSON.stringify(arr),60 * 20)
            cache.set('product_info', JSON.stringify(product_info),60 * 20)
            this.$to_link('/createOrder')
        },
    },
};
</script>
<style lang="scss">
.carshop-wrap {
    h3 {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 20px;
        color: #333333;
    }
    .m-checkbox {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 18px;
        height: 18px;
        border-radius: 4px;
        border: 1px solid #cccccc;
        color: #f9f9f9;
        cursor: pointer;
        transition: all 0.2s;
    }
    .m-checkboxed {
        border: 0;
        background: #0073DF;
        color: #fff;
    }
    table {
        width: 100%;
        margin-top: 20px;
        border-collapse: collapse;
        thead {
            tr {
                height: 48px;
                background: #f9f9f9;
                border: 1px solid #cccccc;
                td {
                    font-size: 14px;
                    color: #333;
                    text-align: center;
                }
            }
        }
        tbody {
            tr {
                height: 140px;
                padding: 20px 0;
                border-bottom: 1px solid #eeeeee;
                .m-goods_img {
                    width: 100px;
                    height: 100px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
                .m-goods_title {
                    width: 141px;
                    height: 40px;
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    line-height: 20px;
                    color: #222222;
                }
                .m-goods_spce {
                    width: 140px;
                    height: 40px;
                    font-size: 13px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    line-height: 20px;
                    color: #999999;
                }
            }
        }
        .td1 {
            display: flex;
            align-items: center;
            padding-left: 20px;
            span {
                font-size: 14px;
                color: #333;
            }
        }
        .m-td-price {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 20px;
            color: #cc0000;
        }
        .m-td-del {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 20px;
            color: #333333;
            cursor: pointer;
            user-select: none;
            &:active {
                opacity: 0.6;
            }
        }
    }

    .carShop-wrap_box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 40px;
        width: 100%;
        height: 60px;
        background: #ffffff;
        border: 1px solid #eeeeee;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.08);
        padding-left: 20px;
        .carShop-wrap_box_font1 {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 20px;
            color: #333333;
        }
        .carShop-wrap_box_font2 {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 20px;
            color: #333333;
            cursor: pointer;
            user-select: none;
            &:active {
                opacity: 0.6;
            }
        }
        .carShop-wrap_box_font3 {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 20px;
            color: #cc0000;
        }
        .carShop-wrap_box_font4 {
            font-size: 12px;
            font-family: Microsoft YaHei;
            line-height: 20px;
            color: #999999;
        }
        .carShop-wrap_box_font5 {
            font-size: 12px;
            font-family: Microsoft YaHei;
            line-height: 20px;
            color: #cc0000;
            font-weight: 800;
        }
        .carShop-wrap_box_btn {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 150px;
            height: 60px;
            background: #0073DF;
            cursor: pointer;
            user-select: none;
            &:active {
                opacity: 0.6;
            }
            span {
                font-size: 16px;
                color: #fff;
            }
        }
        .carShop-wrap_box_left {
            display: flex;
        }
    }
}
</style>
